module.exports = __webpack_public_path__ + "img/AKKOPlan-Icon.3f28b79c.svg";